import { useContext } from 'react';
import { IntlContext } from './intlContext';

export const useIntlContext = () => useContext(IntlContext);
